import * as React from 'react'
import { GridStack } from 'gridstack'
import GridLayout from "react-grid-layout";
import '../../../../../node_modules/react-grid-layout/css/styles.css'



const TOTAL_ROWS = 8;
const TOTAL_COLS = 12;
const DEFAULT_SAMPLE_TYPES = {
    'dbl_blk': {
        'name': 'Double Blank',
        'size': 1,
        'color': '#ffa500',
    },
    'blk': {
        'name': 'Blank',
        'size': 2,
        'color': '#8a2be2',
    },
    'cal': {
        'name': 'Calibrant',
        'size': 7,
        'color': '#228b22',
    },
    'qc': {
        'name': 'Quality Control',
        'size': 3,
        'color': '#ff00ff',
    },
    'exp': {
        'name': 'Experimental',
        'size': 0,
        'color': '#00ffff',
    },

}

export default function GridKit() {
    const rowHeight = 100; // Adjust as needed to make squares
    const cols = TOTAL_COLS;
    const [layout, setLayout] = React.useState([]);

    let initialLayout = [];
    for (let y = 0; y < TOTAL_ROWS; y++) {
        for (let x = 0; x < TOTAL_COLS; x++) {
            
            initialLayout.push({i: `item-${x}-${y}`, x: x, y: y, w: 1, h: 1, key: `item-${x}-${y}`});
        }
    }

    React.useEffect(() => {
        setLayout(initialLayout);
        
    }, []);

    return (
        <div className='d-flex p-3 w-100'>
            <div>
                <GridLayout className="layout bg-light" layout={layout} cols={cols} rowHeight={rowHeight} width={rowHeight*TOTAL_COLS} isResizable={false} compactType='horizontal'>
                    {layout.map((item) => (
                        <div className='shadow-sm bg-body-tertiary' style={{border: '1px solid black', padding: '1px', borderRadius: '5px'}} key={item.i}>Item {item.i}</div>
                    ))}
                    {/* <div className='bg-danger' key='item-0-0' data-grid={{x: 0, y: 0, w: 1, h: 1, static: true}}>Item 0</div>
                    <div className='bg-danger' key='item-1-0' data-grid={{x: 1, y: 0, w: 1, h: 1, static: true}}>Item 1</div> */}
                </GridLayout>
            </div>
        </div>
    );
}

const moveItem = (key, newPosition, layout, setLayout) => {
    // Example: Move item 'a' to a new position
    const newLayout = layout.map(item => {
        if (item.key === key) {
            return {...item, x: newPosition.x, y: newPosition.y}; // new position
        }
        return item;
    });
    setLayout(newLayout);
};